export const updateStaticMetadata=(title='',description='',url='')=>
{
    let title_  = title !== ''? title: 'Seguros a la medida | Médico, Coche y de Mascotas | inter.mx';
    let description_ = (description !== '' || description === '' && url !== '/blog') ? description: 'Encuentra, cotiza y adquiere en un solo lugar Seguro Médico, Seguro para Mascotas y Seguro de Coche y otros productos complementarios.';
    document.title = title_
    let descMeta = document.querySelector("meta[name='description']")
    descMeta.setAttribute("content", description_)
}